import { loadClientConfig, loadRuntimeTenantConfig } from "@/app/app-config";
import { applyWebAppMetadata } from "@/app/web-app-metadata";
import { ErrorLogger } from "@/utils/module_api";

let app_bootstrapped = false;

function ensure_tab_id() {
  try {
    const existing = sessionStorage.getItem("tabId");
    if (existing) return;
    const generated =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("tabId", generated);
  } catch {
    // ignore session storage failures
  }
}

function ensure_secure_websocket_shim() {
  const CurrentWebSocket = window.WebSocket as any;
  if (CurrentWebSocket?.__switchWrapped) return;
  const OriginalWebSocket = window.WebSocket;
  // @ts-ignore
  const WrappedWebSocket = function (url: string, ...args: any[]) {
    let nextUrl = url;
    if (nextUrl.startsWith("ws://")) {
      nextUrl = nextUrl.replace("ws://", "wss://");
    }
    // @ts-ignore
    return new OriginalWebSocket(nextUrl, ...args);
  } as any;
  WrappedWebSocket.__switchWrapped = true;
  WrappedWebSocket.prototype = OriginalWebSocket.prototype;
  // @ts-ignore
  window.WebSocket = WrappedWebSocket;
}

export async function bootApp(): Promise<void> {
  if (app_bootstrapped) return;
  app_bootstrapped = true;

  try {
    ensure_secure_websocket_shim();
    ensure_tab_id();
    await loadRuntimeTenantConfig();
    await loadClientConfig();
    applyWebAppMetadata();
    console.log("[bootstrap/app] app boot complete");
  } catch (err) {
    ErrorLogger.logError(err as Error, "app_bootstrap");
    console.warn("[bootstrap/app] boot failed", err);
    throw err;
  }
}
